// TODO выпилить при обогащении api монолита getContext цветами станций CD-68938
import hardcodedMetroColorsEntries from './metroColorEntries';

// Список ID городов с собственными иконками метро
const LOCATIONS_WITH_UNDERGROUND_ICON = [
  1,    // Москва
  2,    // Санкт-Петербург
  4966, // Самара
  4897, // Новосибирск
  4885, // Нижний
  4777, // Казань
  4743, // Екатеринбург
];

export default angular
  .module('cian.addForm.metroIcon', [])
  .directive('cianAfMetroIcon', [
    () => ({
      scope: {},
      bindToController: {
        stationId: '@',
        lineColor: '@',
        locationId: '@',
      },
      template: `
      <cian-af-icon
        name='{{ metroIcon.name }}'
        ng-style='{ fill: metroIcon.color }'
      ></cian-af-icon>
    `.trim(),
      controller: [
        '$scope',
        function($scope) {
          const ctrl = this;
          function getColor(stationId) {
            if (!stationId) {
              return '#000';
            }
            const [color] =
              hardcodedMetroColorsEntries.find(
                entry =>
                  entry[1].find(id => id === Number(stationId)) !== undefined
              ) || [];
            return `#${color}` || '#000';
          }

          function updateIcon() {
            ctrl.name = LOCATIONS_WITH_UNDERGROUND_ICON.includes(
              Number(ctrl.locationId)
            )
              ? `underground_${ctrl.locationId}`
              : 'underground';
            ctrl.color = ctrl.lineColor
              ? `#${ctrl.lineColor}`
              : getColor(ctrl.stationId);
          }

          updateIcon();
          // Следим за изменением цвета
          // Следим за изменением города, чтобы обновить иконку
          // Следим за ID станции на случай если не передан цвет TODO выпилить после CD-68938
          $scope.$watchGroup(
            [() => ctrl.lineColor, () => ctrl.locationId, () => ctrl.stationId],
            (
              [colorNew, locationNew, stationIdNew],
              [colorOld, locationOld, stationIdOld]
            ) => {
              if (
                colorNew !== colorOld ||
                (locationNew && locationNew !== locationOld) ||
                stationIdNew !== stationIdOld
              ) {
                updateIcon();
              }
            }
          );
        },
      ],
      controllerAs: 'metroIcon',
    }),
  ]).name;
